import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import CourseService from '../../../service/courseService'
import Table from 'react-bootstrap/Table'
import useToken from '../../../App/useToken'
import './Courses.css'

export default function Courses() {
  const { major_name } = useParams()
  const { isAdmin, getToken } = useToken()
  const token = getToken()
  const [isLoading, setIsLoading] = useState(true)
  const [listitems, setListitems] = useState([])
  const isUserAdmin = isAdmin()
  useEffect(() => {
    const checkToken = async () => {
      const courseService = new CourseService()
      const res = await courseService.getCourseByMajorName(major_name, token)
      if (res?.length > 0) {
        setListitems(res)
      }
      console.log(res)
      return res
    }
    checkToken()
    setIsLoading(false)
  }, [])

  return (
    <div className='course-list'>
      {!isLoading && (
        <div clalssname='container'>
          <Breadcrumb>
            <Breadcrumb.Item href='/majorcourses'>Home</Breadcrumb.Item>
            <Breadcrumb.Item active href='#'>
              {major_name}
            </Breadcrumb.Item>
          </Breadcrumb>
          {/* {!isLoading && <div clalssname="container" style={{ overflow: 'auto' }}> */}
          {isUserAdmin && (
            <a
              className='btn btn-outline-success btn-sm btn-creat-course'
              href={`/majorcourses/${major_name}/course/create`}>
              เพิ่มหลักสูตร
            </a>
          )}
          <br />
          <Table striped hover style={{ width: '80rem' }}>
            <thead>
              <tr>
                <th style={{ width: '5%' }}>#</th>
                <th style={{ width: '75%' }}>ชื่อหลักสูตร</th>
                <th style={{ width: '10%' }}>
                  <span className='right'>จำนวนที่รับ</span>
                </th>
                <th style={{ width: '10%' }}>
                  <span className='right'>จำนวนคงค้าง</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {listitems !== [] &&
                listitems.map((listitem, index) => (
                  <tr
                    key={listitem._id}
                    onClick={() => {
                      window.location.href = `${major_name}/course/${listitem.name}`
                    }}>
                    <td>{index + 1}</td>
                    <td>{listitem.name}</td>
                    <td>
                      <span className='right'>{listitem.amount}</span>
                    </td>
                    <td>
                      <span className='right'>
                        {listitem.studentcourseCount}
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}
